module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/绿色制造.c8a80c4d.png";